export { FacilityDetailV2Connected as FacilityDetailV2 } from './container';
